<template>
    <v-select v-model="sort" v-bind="{ ...$attrs, items }" class="v-input--large w-lg-240px" @change="emit" />
</template>

<script>
import { RECRUITMENT_LIST_SORTS } from "@/assets/variables";

const items = Object.values(RECRUITMENT_LIST_SORTS);
const sort__initial = RECRUITMENT_LIST_SORTS.CREATED_AT_DESC.value;

export default {
    data: () => ({
        sort: sort__initial,
        items,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        "$route.query.sort"() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.sort = this.$route.query.sort || sort__initial;
        },
        emit() {
            const { ...query } = this.$route.query;

            delete query.page;
            query.sort = this.sort;

            this.$router.push({ query });
        },
    },
};
</script>

<style>
</style>